import { Button, Card, Col, Form, Modal, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import Select from "react-select";
import WorkLineForm from "./WorkLineForm";
import { useDispatch, useSelector } from "react-redux";
import { useAuth } from "../auth/useAuth";
import { getAnalisysTypes } from "../../actions/analisysTypesActions";
import { getParameters } from "../../actions/parametersActions";
import Swal from "sweetalert2";

export default function BudgetForm({
    state,
    businessesActive,
    handleInputChange,
    submit,
    isAddingOrEditing,
    isRegistering,
    userType,
    handleConvertToWO
}) {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const { clientauth } = useAuth()
    const [modalShow, setModalShow] = useState(false)
    const [formState, setFormState] = useState({})
    const isReadOnly = isAddingOrEditing === "viewing";
    const { analisysTypes } = useSelector(state => state.analisysTypes)
    const { parameters } = useSelector(state => state.parameters)
    const [isEditing, setIsEditing] = useState(false)
    const [editingIndex, setEditingIndex] = useState(null)
    const { numbudget } = useSelector(state => state.budgets)
    const [workLineType, setWorkLineType] = useState(false)

    const businessesList = Array.isArray(businessesActive?.[0])
        ? businessesActive[0]
        : businessesActive || [];

    const [workLines, setWorkLines] = useState(state.workLines || []);

    const [workLineAux, setWorkLineAux] = useState({ typeLine: "Análisis", description: "", quantity: 0, params: [] });

    useEffect(() => {
        if (clientauth) {
            dispatch(getAnalisysTypes())
            dispatch(getParameters())
        }
    }, [dispatch, t, clientauth])

    const openModal = (index, analisis) => {
        setWorkLineType(analisis)

        if (Number.isInteger(index)) {
            setIsEditing(true)
            setEditingIndex(index);
            const line = workLines[index];
            setWorkLineAux(() => ({
                typeLine: line.typeLine || analisis,
                description: line.description || "",
                price: line.price || 0,
                recurrence: line.recurrence || "Sin recurrencia",
                quantity: line.quantity || 0,
                params: Array.isArray(line.params) ? line.params : [],
                status: line.status || "Pendiente",
                amountRecurrence: line.amountRecurrence || 1
            }));
        }
        else {
            setIsEditing(false)
            setEditingIndex(null);
            setWorkLineAux(() => ({
                typeLine: analisis,
                description: "",
                price: 0,
                recurrence: "Sin recurrencia",
                quantity: 0,
                params: [],
                status: "Pendiente",
                amountRecurrence: 1
            }));
        }
        setModalShow(true)
    };

    const removeWorkLine = (index) => {
        const updated = workLines.filter((_, i) => i !== index);
        setWorkLines(updated);
        handleInputChange({ target: { name: "workLines", value: updated } });
    };

    const handleInputChangeModal = ({ target }) => {
        setWorkLineAux(prev => ({
            ...prev,
            [target.name]: target.value
        }))
    }

    const handleSelectChangeModal = ({ target }) => {
        setWorkLineAux(prev => ({
            ...prev,
            [target.name]: target.value
        }))
    }

    const handleSubmitModal = () => {
        let updated;

        if (isEditing && Number.isInteger(editingIndex)) {
            updated = workLines.map((line, i) =>
                i === editingIndex ? { ...line, ...workLineAux } : line
            );
        } else {
            updated = [...workLines, workLineAux];
        }

        setWorkLines(updated);

        handleInputChange({
            target: { name: "workLines", value: updated }
        });

        setWorkLineAux({
            typeLine: "Análisis",
            description: "",
            quantity: 0,
            params: [],
            price: 0,
            recurrence: "Sin recurrencia",
            status: "Pendiente",
            amountRecurrence: 1
        });

        setModalShow(false);
    };

    return (
        <>
            <Form onSubmit={submit} className="px-4 formulario">
                <Row className="my-3">
                    <Col xs={12} lg={3}>
                        <Form.Label>{t("admin.budgets.numbudget")}</Form.Label>
                        <Form.Control
                            className="sd-input"
                            type="number"
                            name="numBudget"
                            value={state.numBudget || numbudget || ""}
                            readOnly
                        />
                    </Col>

                    <Col xs={12} lg={3}>
                        <Form.Label>{t("admin.budgets.date")}</Form.Label>
                        <Form.Control
                            className="sd-input"
                            type="date"
                            name="date"
                            value={state.date || new Date().toISOString().split("T")[0]}
                            onChange={handleInputChange}
                            readOnly={isReadOnly}
                            required
                        />
                    </Col>

                    <Col xs={12} lg={6}>
                        <Form.Label>{t("admin.budgets.business")}</Form.Label>
                        <Select
                            className="select"
                            classNamePrefix="sd-select"
                            options={businessesList.map(b => ({
                                value: b._id,
                                label: b.name
                            }))}
                            value={
                                businessesList.find(b => b._id === state.business)
                                    ? {
                                        value: state.business,
                                        label: businessesList.find(b => b._id === state.business)?.name
                                    }
                                    : null
                            }
                            onChange={(selected) =>
                                handleInputChange({
                                    target: { name: "business", value: selected.value }
                                })
                            }
                            placeholder={t("admin.budgets.selectBusiness")}
                            isDisabled={isReadOnly}
                            required
                        />
                    </Col>
                </Row>

                <Row className="my-3">
                    <Col xs={12} md={12}>
                        <Form.Label>{t("admin.budgets.description")}</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={2}
                            name="description"
                            value={state.description || ""}
                            onChange={handleInputChange}
                            readOnly={isReadOnly}
                        />
                    </Col>
                </Row>

                <Row className="my-3">
                    <Col xs={12} md={6}>
                        <Form.Label>{t("admin.budgets.observations")}</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            name="observations"
                            value={state.observations || ""}
                            onChange={handleInputChange}
                            readOnly={isReadOnly}
                        />
                    </Col>

                    <Col xs={12} md={6}>
                        <Form.Label>{t("admin.budgets.conditions")}</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            name="conditions"
                            value={state.conditions || ""}
                            onChange={handleInputChange}
                            readOnly={isReadOnly}
                        />
                    </Col>
                </Row>

                <Row className="my-3">
                    <Col xs={12} md={4}>
                        <Form.Label>{t("admin.budgets.validity")}</Form.Label>
                        <Form.Control
                            className="sd-input"
                            type="date"
                            name="validity"
                            value={state.validity ? new Date(state.validity).toISOString().split("T")[0] : ""}
                            onChange={handleInputChange}
                            readOnly={isReadOnly}
                        />
                    </Col>

                    <Col xs={12} md={8}>
                        <Form.Label>{t("admin.budgets.otherData")}</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={2}
                            name="otherData"
                            value={state.otherData || ""}
                            onChange={handleInputChange}
                            readOnly={isReadOnly}
                        />
                    </Col>
                </Row>
                <hr />
                <Row className="my-4">
                    <Col xs={12}>
                        <div className="d-flex flex-column flex-lg-row align-items-lg-center justify-content-lg-between gap-2 mb-2">
                            <h5 className="mb-0">{t("admin.budgets.workLines")}</h5>

                            {!isReadOnly && (
                                <div className="d-flex gap-2">
                                    <Button variant="fourth" onClick={() => { openModal(null, "Análisis") }}>
                                        {t("admin.budgets.addAnalysisType")}
                                    </Button>

                                    <Button variant="secondary" onClick={() => { openModal(null, "Servicio") }}>
                                        {t("admin.budgets.addExtraService")}
                                    </Button>
                                </div>
                            )}
                        </div>
                    </Col>
                </Row>
                <Row>
                    {workLines.length > 0 ? (
                        workLines.map((line, index) => {
                            const isAnalysis = line.typeLine === "Análisis";
                            const totalParams = isAnalysis ? (line.params?.length || 0) : null;

                            return (
                                <Col key={index} xs={12} md={4} className="mb-4">
                                    <Card className="h-100 shadow-sm">
                                        <Card.Body className="p-4 d-flex flex-column">

                                            <div className="d-flex justify-content-between align-items-start mb-3">
                                                <div>
                                                    <div className="text-uppercase text-secondary fw-semibold small">
                                                        {isAnalysis ? "Tipo de análisis" : "Servicio extra"}
                                                    </div>
                                                    {isAnalysis && (
                                                        <h5 className="m-0 fw-bold fs-4">
                                                            {line.description || t("admin.budgets.workLineDescription")}
                                                        </h5>
                                                    )}
                                                </div>

                                                <div className="d-flex gap-2">
                                                    {(state.state === "Aprobado") && isAnalysis && (
                                                        <Button
                                                            variant="light"
                                                            className="p-2 rounded-circle shadow-sm"
                                                            onClick={(e) => handleConvertToWO(e, state.id, index)}
                                                            disabled={line.status !== "Pendiente"}
                                                        >
                                                            <i class="fa-solid fa-arrow-right-from-bracket"></i>
                                                        </Button>
                                                    )}
                                                    {!isReadOnly ? (
                                                        <>
                                                            <Button
                                                                variant="light"
                                                                className="p-2 rounded-circle shadow-sm"
                                                                onClick={() => openModal(index, line.typeLine)}
                                                            >
                                                                <i className="fas fa-pencil"></i>
                                                            </Button>

                                                            <Button
                                                                variant="light"
                                                                className="p-2 rounded-circle shadow-sm text-danger"
                                                                onClick={() => removeWorkLine(index)}
                                                            >
                                                                <i className="fas fa-trash"></i>
                                                            </Button>
                                                        </>
                                                    ) : (
                                                        isAnalysis && (
                                                            <Button
                                                                variant="light"
                                                                className="p-2 rounded-circle shadow-sm"
                                                                onClick={() => openModal(index)}
                                                            >
                                                                <i className="fa-solid fa-eye"></i>
                                                            </Button>
                                                        )
                                                    )}
                                                </div>
                                            </div>

                                            <Row className="mb-3">
                                                <Col xs={6}>
                                                    <div className="fw-semibold text-secondary">
                                                        {t("admin.budgets.price")} (€)
                                                    </div>
                                                    <div className="fs-5 fw-bold">
                                                        {line.price} €
                                                    </div>
                                                </Col>

                                                <Col xs={6}>
                                                    <div className="fw-semibold text-secondary">
                                                        {t("admin.budgets.recurrence")}
                                                    </div>
                                                    <div className="fs-6 fw-semibold">
                                                        {line.recurrence}
                                                    </div>
                                                </Col>
                                            </Row>

                                            {isAnalysis ?
                                                <>
                                                    <div className="mt-auto pt-3 border-top">
                                                        <Row>
                                                            <Col xs={6}>
                                                                <div className="fw-semibold text-secondary">{t("admin.budgets.analisysQuantity")}</div>
                                                                <div className="fs-6 fw-semibold">{line.quantity}</div>
                                                            </Col>
                                                            <Col xs={6}>
                                                                <div className="fw-semibold text-secondary">Total parámetros</div>
                                                                <div className="fs-6 fw-semibold">{totalParams}</div>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </>
                                                :
                                                <>
                                                    <div className="mt-auto pt-3 border-top flex-grow-1 d-flex align-items-start">
                                                        <div className="w-100">
                                                            <div className="fw-semibold text-secondary mb-1">
                                                                {t("admin.budgets.workLineDescription")}
                                                            </div>
                                                            <p className="mb-0" style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                                                                {line.description || "—"}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </>
                                            }
                                        </Card.Body>
                                    </Card>
                                </Col>
                            );
                        })
                    ) : (
                        <Col xs={12}>{t("admin.budgets.noWorkLines")}</Col>
                    )}
                </Row>

                <Row className="my-3 align-items-end justify-content-end">
                    {isAddingOrEditing === "editing" && (
                        <Col xs={12} lg={2}>
                            <Form.Label>{t("admin.budgets.state")}</Form.Label>
                            <Select
                                className="select"
                                classNamePrefix="sd-select"
                                options={[
                                    { value: "Pendiente", label: "Pendiente" },
                                    { value: "Aprobado", label: "Aprobado" },
                                    { value: "Rechazado", label: "Rechazado" },
                                    { value: "Cancelado", label: "Cancelado" }
                                ]}
                                value={{ value: state.state, label: state.state }}
                                onChange={(selected) =>
                                    handleInputChange({
                                        target: { name: "state", value: selected.value }
                                    })
                                } />
                        </Col>
                    )}

                    <Col xs={12} lg={4} className="d-flex align-items-end">
                        {userType === "Admin" && !isReadOnly && (
                            <Button variant="primary" type="submit" className="w-100">
                                {isRegistering
                                    ? <span className="spinner-border spinner-border-sm"></span>
                                    : isAddingOrEditing === "editing"
                                        ? t("global.edit")
                                        : t("global.register")}
                            </Button>
                        )}
                    </Col>
                </Row>

            </Form >
            <Modal
                show={modalShow}
                onHide={() => setModalShow(false)}
                size="lg"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        <h2>{isReadOnly ? t('admin.budgets.paramList') : t('admin.budgets.workLine')}</h2>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <WorkLineForm
                        state={formState}
                        handleInputChange={handleInputChangeModal}
                        parameters={parameters}
                        analisysTypes={analisysTypes}
                        handleSelectChange={handleSelectChangeModal}
                        submit={handleSubmitModal}
                        workLine={workLineAux}
                        isEditing={isEditing}
                        isReadOnly={isReadOnly}
                        workLineType={workLineType}
                    />
                </Modal.Body>
            </Modal>
        </>
    );
}